/* eslint-disable max-len, no-param-reassign, no-unused-vars */
/**
 * Air theme JavaScript.
 */

// Import modules
import reframe from 'reframe.js';
import {
  styleExternalLinks,
  initExternalLinkLabels,
} from './modules/external-link';
import initAnchors from './modules/anchors';
import initA11ySkipLink from './modules/a11y-skip-link';
import initA11yFocusSearchField from './modules/a11y-focus-search-field';
import initHomeHeroSlider from './modules/home-hero-slider';
import initEksodiSlider from './modules/eksodi-slider';
import initEksodiMakingReadmore from './modules/eksodi-making-readmore';
import initHistoryTimeline from './modules/history-timeline';
import initHistoryVideo from './modules/history-video';
import initExhibitionPopup from './modules/exhibition-popup';
import initInfiniteScroll from './modules/infinite-scroll';
import initSearchOverlay from './modules/search-overlay';
import initSupportBanner from './modules/support-banner';
import initHomeVideo from './modules/home-video';
import initLanguageSwitcher from './modules/language-switcher';
import {
  navSticky,
  navClick,
  navDesktop,
  navMobile,
} from './modules/navigation';
// Define Javascript is active by changing the body class
document.body.classList.remove('no-js');
document.body.classList.add('js');

document.addEventListener('DOMContentLoaded', () => {
  initAnchors();
  styleExternalLinks();
  initExternalLinkLabels();
  initA11ySkipLink();
  initA11yFocusSearchField();
  initHomeHeroSlider();
  initEksodiSlider();
  initEksodiMakingReadmore();
  initHistoryTimeline();
  initHistoryVideo();
  initExhibitionPopup();
  initInfiniteScroll();
  initSearchOverlay();
  initSupportBanner();
  initHomeVideo();
  initLanguageSwitcher();

  // Init navigation
  // If you want to enable click based navigation, comment navDesktop() and uncomment navClick()
  // Remember to enable styles in assets/src/sass/navigation/navigation.scss
  navDesktop();
  // navClick();
  navMobile();

  // Uncomment if you like to use a sticky navigation
  // navSticky();

  // Fit video embeds to container
  reframe('.wp-has-aspect-ratio iframe');
});
